import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedPipesModule } from '@shared/pipes/shared-pipes.module';
import { ProjectDiscussionAddCommentModule } from '../project-discussion-add-comment/project-discussion-add-comment.module';
import { ProjectDiscussionChatHeaderComponent } from './components/project-discussion-chat-header/project-discussion-chat-header.component';
import { ProjectDiscussionChatRepliesComponent } from './components/project-discussion-chat-replies/project-discussion-chat-replies.component';
import { ProjectDiscussionChatReplyComponent } from './components/project-discussion-chat-reply/project-discussion-chat-reply.component';
import { ProjectDiscussionChatComponent } from './components/project-discussion-chat/project-discussion-chat.component';

@NgModule({
    declarations: [],
    exports: [
        ProjectDiscussionChatComponent,
        ProjectDiscussionChatHeaderComponent,
        ProjectDiscussionChatRepliesComponent,
        ProjectDiscussionChatReplyComponent,
    ],
    imports: [
        CommonModule,
        SharedPipesModule,
        ProjectDiscussionAddCommentModule,
        ProjectDiscussionChatComponent,
        ProjectDiscussionChatHeaderComponent,
        ProjectDiscussionChatRepliesComponent,
        ProjectDiscussionChatReplyComponent,
    ]
})
export class ProjectDiscussionChatModule { }
